import Overview from './pages/Overview'
import NotFound from './pages/NotFound'
import Login from './pages/Login'
import AuthenticatedPage from './components/AuthenticatedPage'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AlertProvider } from './contexts/alert-context'
import { DeviceProvider } from './contexts/device-context'
import { UserProvider } from './contexts/user-context'
import { HistoryProvider } from './contexts/history-context'
import LiveFeed from './pages/LiveFeed'
import CustomerTurnover from './pages/CustomerTurnover'
import Customer from './pages/Customer'
import Customers from './pages/Customers'
import Groceries from './pages/Groceries'
import { getTodayText } from './utils/dateUtils'

function App() {
  return (
    <div className="App">
      <DeviceProvider>
        <AlertProvider>
          <UserProvider>
            <HistoryProvider>
              <Routes>
                <Route
                  path="/overview"
                  element={
                    <AuthenticatedPage pageTitle={`Idag ${getTodayText()}`}>
                      <Overview />
                    </AuthenticatedPage>
                  }
                />
                <Route
                  path="/live-feed"
                  element={
                    <AuthenticatedPage pageTitle='Live-flöde'>
                      <LiveFeed />
                    </AuthenticatedPage>
                  }
                />
                <Route
                  path="/live-feed/:sessionId"
                  element={
                    <AuthenticatedPage pageTitle='Live-flöde'>
                      <LiveFeed />
                    </AuthenticatedPage>
                  }
                />
                <Route
                  path={'/sessions'}
                  element={
                    <AuthenticatedPage pageTitle='Kundvarv'>
                      <CustomerTurnover />
                    </AuthenticatedPage>
                  }
                />
                <Route
                  path="/sessions/:sessionId"
                  element={
                    <AuthenticatedPage pageTitle='Kundvarv'>
                      <CustomerTurnover />
                    </AuthenticatedPage>
                  }
                />
                <Route
                  path="/customers"
                  element={
                    <AuthenticatedPage pageTitle='Kunder'>
                      <Customers />
                    </AuthenticatedPage>
                  }
                />
                <Route
                  path="/customers/:id/:countryCode"
                  element={
                    <AuthenticatedPage>
                      <Customer />
                    </AuthenticatedPage>
                  }
                />
                <Route
                  path="/customers/:id/:countryCode/:sessionId"
                  element={
                    <AuthenticatedPage>
                      <Customer />
                    </AuthenticatedPage>
                  }
                />
                <Route
                  path="/groceries"
                  element={
                    <AuthenticatedPage pageTitle='Sortiment'>
                      <Groceries />
                    </AuthenticatedPage>
                  }
                />
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Navigate replace to="/overview" />} />
                <Route
                  path="*"
                  element={
                    <NotFound />
                  }
                />
              </Routes>
            </HistoryProvider>
          </UserProvider>
        </AlertProvider>
      </DeviceProvider>
      <div id='modal-portal'></div>
    </div>
  )
}

export default App
